import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { BiometricsPage } from "./biometrics";

@NgModule({
  declarations: [BiometricsPage],
  imports: [
    IonicPageModule.forChild(BiometricsPage),
    TranslateModule.forChild(),
    CommonComponentsModule,
  ],
})
export class PatientBiometricsModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/biometrics/biometrics.module.ts